// extracted by mini-css-extract-plugin
module.exports = {"shareBtnContainer":"SocialShare_shareBtnContainer__lvagy","shareBtn":"SocialShare_shareBtn__3IxgI","xs":"SocialShare_xs__2cA5h","sm":"SocialShare_sm__2Qsmz"};